// extracted by mini-css-extract-plugin
export default {"loader":"PageLoading_loader__pbfOb"};